import { render } from "./Bill_confirmation.vue?vue&type=template&id=12db334c"
import script from "./Bill_confirmation.vue?vue&type=script&lang=js"
export * from "./Bill_confirmation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__